import { Controller } from "@hotwired/stimulus"
import * as THREE from "three"

export default class extends Controller {
  static targets = ["canvas"]

  // Only books with valid covers (removed broken 43-byte files)
  bookData = [
    { cover: "/books/think-and-grow-rich.jpg", title: "Think and Grow Rich", author: "Napoleon Hill", spine: "THINK AND GROW RICH", back: "The classic guide to wealth through mindset. Learn the 13 principles of success. Transform your thoughts into riches." },
    { cover: "/books/law-of-success.jpg", title: "The Law of Success", author: "Napoleon Hill", spine: "LAW OF SUCCESS", back: "The complete philosophy of achievement. Master the 16 lessons of success. Build your path to greatness." },
    { cover: "/books/outwitting-the-devil.jpg", title: "Outwitting the Devil", author: "Napoleon Hill", spine: "OUTWITTING THE DEVIL", back: "Break free from fear and procrastination. Discover the secrets of self-discipline. Unlock your true potential." },
    { cover: "/books/how-to-win-friends.jpg", title: "How to Win Friends", author: "Dale Carnegie", spine: "WIN FRIENDS", back: "Master the art of human relations. Influence people with integrity. Build lasting connections." },
    { cover: "/books/7-habits.jpg", title: "7 Habits of Highly Effective People", author: "Stephen Covey", spine: "7 HABITS", back: "Transform your effectiveness forever. Principles for personal change. From dependence to interdependence." },
    { cover: "/books/power-of-now.jpg", title: "The Power of Now", author: "Eckhart Tolle", spine: "POWER OF NOW", back: "Awaken to the present moment. Transcend your ego mind. Find peace in the now." },
    { cover: "/books/alchemist.jpg", title: "The Alchemist", author: "Paulo Coelho", spine: "THE ALCHEMIST", back: "Follow your personal legend. A fable about following dreams. Discover the soul of the world." },
    { cover: "/books/atomic-habits.jpg", title: "Atomic Habits", author: "James Clear", spine: "ATOMIC HABITS", back: "Tiny changes, remarkable results. Master the science of habits. Build systems for success." },
    { cover: "/books/subtle-art.jpg", title: "The Subtle Art", author: "Mark Manson", spine: "SUBTLE ART", back: "Stop trying to be positive. Embrace life's struggles. Find meaning through values." },
    { cover: "/books/rich-dad-poor-dad.jpg", title: "Rich Dad Poor Dad", author: "Robert Kiyosaki", spine: "RICH DAD", back: "What the rich teach their kids. Financial education essentials. Build assets, not liabilities." },
    { cover: "/books/4-hour-workweek.jpg", title: "4-Hour Workweek", author: "Tim Ferriss", spine: "4-HOUR WORKWEEK", back: "Escape the 9-5 forever. Design your ideal lifestyle. Join the new rich." },
    { cover: "/books/start-with-why.jpg", title: "Start with Why", author: "Simon Sinek", spine: "START WITH WHY", back: "Great leaders inspire action. Discover your purpose first. Lead with conviction." },
    { cover: "/books/thinking-fast-slow.jpg", title: "Thinking, Fast and Slow", author: "Daniel Kahneman", spine: "THINKING FAST", back: "Two systems drive your thoughts. Understand cognitive biases. Make better decisions." },
    { cover: "/books/mindset.jpg", title: "Mindset", author: "Carol Dweck", spine: "MINDSET", back: "Fixed vs growth mindset. Transform your abilities. Embrace the power of yet." },
    { cover: "/books/grit.jpg", title: "Grit", author: "Angela Duckworth", spine: "GRIT", back: "Passion and perseverance matter. Talent is overrated. Develop your grit." },
    { cover: "/books/the-secret.jpg", title: "The Secret", author: "Rhonda Byrne", spine: "THE SECRET", back: "The law of attraction revealed. Your thoughts shape reality. Manifest your desires." },
    { cover: "/books/you-are-a-badass.jpg", title: "You Are a Badass", author: "Jen Sincero", spine: "BADASS", back: "Stop doubting your greatness. Create a life you love. Embrace your inner badass." },
    { cover: "/books/power-positive-thinking.jpg", title: "Power of Positive Thinking", author: "Norman V. Peale", spine: "POSITIVE THINKING", back: "Faith over fear always. Change your thoughts, change life. Practical optimism guide." },
    { cover: "/books/awaken-giant-within.jpg", title: "Awaken the Giant Within", author: "Tony Robbins", spine: "AWAKEN GIANT", back: "Take control of your destiny. Master your emotions and life. Unleash your true power." },
    { cover: "/books/unlimited-power.jpg", title: "Unlimited Power", author: "Tony Robbins", spine: "UNLIMITED POWER", back: "The science of personal achievement. Model excellence in others. Transform yourself completely." },
    { cover: "/books/magic-thinking-big.jpg", title: "Magic of Thinking Big", author: "David Schwartz", spine: "THINK BIG", back: "Set bigger goals always. Believe and you will succeed. Think your way to success." },
    { cover: "/books/as-a-man-thinketh.jpg", title: "As a Man Thinketh", author: "James Allen", spine: "AS A MAN THINKETH", back: "You become your thoughts. Master your mental garden. Classic wisdom for life." },
    { cover: "/books/science-getting-rich.jpg", title: "Science of Getting Rich", author: "Wallace Wattles", spine: "GETTING RICH", back: "There is a science to wealth. Think in the certain way. Abundance is your birthright." },
    { cover: "/books/psycho-cybernetics.jpg", title: "Psycho-Cybernetics", author: "Maxwell Maltz", spine: "PSYCHO-CYBERNETICS", back: "Your self-image is key. Reprogram your mental computer. Become the new you." },
    { cover: "/books/dotcom-secrets.jpg", title: "DotCom Secrets", author: "Russell Brunson", spine: "DOTCOM SECRETS", back: "Underground playbook for growth. Build converting funnels. Scale your online business." },
    { cover: "/books/traffic-secrets.jpg", title: "Traffic Secrets", author: "Russell Brunson", spine: "TRAFFIC SECRETS", back: "Fill your funnels with buyers. Master paid and organic traffic. Find your dream customers." },
    { cover: "/books/no-bs-direct-marketing.jpg", title: "No B.S. Direct Marketing", author: "Dan Kennedy", spine: "NO B.S. MARKETING", back: "Results-only marketing strategies. Cut the fluff and sell. Direct response that works." },
    { cover: "/books/influence-new.jpg", title: "Influence", author: "Robert Cialdini", spine: "INFLUENCE", back: "The psychology of persuasion. Six principles of influence. Ethical persuasion mastery." },
    { cover: "/books/made-to-stick.jpg", title: "Made to Stick", author: "Chip & Dan Heath", spine: "MADE TO STICK", back: "Why some ideas survive. Make your message memorable. The SUCCESs formula." },
    { cover: "/books/building-storybrand.jpg", title: "Building a StoryBrand", author: "Donald Miller", spine: "STORYBRAND", back: "Clarify your message. Customer is the hero. Story sells everything." },
    { cover: "/books/contagious.jpg", title: "Contagious", author: "Jonah Berger", spine: "CONTAGIOUS", back: "Why things catch on. The science of virality. Make ideas spread." },
    { cover: "/books/jab-jab-jab.jpg", title: "Jab, Jab, Jab, Right Hook", author: "Gary Vaynerchuk", spine: "JAB JAB JAB", back: "Give before you ask. Social media storytelling. Context is everything." },
    { cover: "/books/lean-startup.jpg", title: "The Lean Startup", author: "Eric Ries", spine: "LEAN STARTUP", back: "Build measure learn fast. Validated learning approach. Fail forward quickly." },
    { cover: "/books/zero-to-one.jpg", title: "Zero to One", author: "Peter Thiel", spine: "ZERO TO ONE", back: "Create something new. Monopoly beats competition. Future belongs to builders." },
    { cover: "/books/good-to-great.jpg", title: "Good to Great", author: "Jim Collins", spine: "GOOD TO GREAT", back: "Why some companies leap. The hedgehog concept. Level 5 leadership." },
    { cover: "/books/e-myth-revisited.jpg", title: "The E-Myth Revisited", author: "Michael Gerber", spine: "E-MYTH", back: "Work on not in business. Systems set you free. Franchise your operations." },
    { cover: "/books/this-is-marketing.jpg", title: "This Is Marketing", author: "Seth Godin", spine: "THIS IS MARKETING", back: "Marketing is about change. Find your smallest viable market. Make things better." },
    { cover: "/books/48-laws-power.jpg", title: "48 Laws of Power", author: "Robert Greene", spine: "48 LAWS", back: "Master the game of power. History's strategic lessons. Play to win wisely." },
  ]

  // Cycling labels for the center
  cyclingLabels = ["Your Collection", "Your Authors", "Your Categories", "Your Study Groups", "Your Wishlist", "Your Reading List", "Your Publishers"]

  connect() {
    if (!this.hasCanvasTarget) return
    if (!this.isWebGLAvailable()) {
      this.element.style.display = "none"
      return
    }
    this.setupIntersectionObserver()
  }

  disconnect() {
    this.cleanup()
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.initialized) {
          this.initScene()
          this.observer.disconnect()
        }
      })
    }, { threshold: 0.1 })
    this.observer.observe(this.element)
  }

  isWebGLAvailable() {
    try {
      const canvas = document.createElement("canvas")
      return !!(window.WebGLRenderingContext && (canvas.getContext("webgl") || canvas.getContext("experimental-webgl")))
    } catch (e) {
      return false
    }
  }

  initScene() {
    if (this.initialized) return
    this.initialized = true

    const canvas = this.canvasTarget
    const container = canvas.parentElement
    const width = container.clientWidth
    const height = container.clientHeight || 450

    this.scene = new THREE.Scene()
    this.camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1000)
    this.camera.position.set(0, 0, 7)

    this.renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true })
    this.renderer.setSize(width, height)
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    this.renderer.outputColorSpace = THREE.SRGBColorSpace

    this.clock = new THREE.Clock()
    this.time = 0
    this.activeBooks = []
    this.textureLoader = new THREE.TextureLoader()
    this.loadedTextures = {}
    this.currentLabelIndex = 0
    this.labelFadeProgress = 0

    this.addLights()
    this.createCenterIcon()

    // Create rotating group for books and lines
    this.orbitGroup = new THREE.Group()
    this.scene.add(this.orbitGroup)

    this.createConnectionLines()
    this.spawnInitialBooks()

    // Start label cycling
    setInterval(() => this.cycleLabel(), 2500)

    this.animate()
    this.setupResizeObserver()
  }

  addLights() {
    // Brighter warm ambient light
    const ambient = new THREE.AmbientLight(0xfff8f0, 1.2)
    this.scene.add(ambient)

    // Main key light - warm and bright
    this.keyLight = new THREE.DirectionalLight(0xffeedd, 1.2)
    this.keyLight.position.set(3, 4, 5)
    this.scene.add(this.keyLight)

    // Shimmer light for dynamic highlights
    this.shimmerLight = new THREE.PointLight(0xffd700, 0.5, 12)
    this.shimmerLight.position.set(0, 0, 4)
    this.scene.add(this.shimmerLight)

    // Warm fill light from the side
    const fill = new THREE.DirectionalLight(0xffe4c4, 0.6)
    fill.position.set(-4, 2, 3)
    this.scene.add(fill)

    // Warm back light
    const rim = new THREE.DirectionalLight(0xd4b896, 0.4)
    rim.position.set(0, 0, -5)
    this.scene.add(rim)

    // Additional front fill for brightness
    const frontFill = new THREE.DirectionalLight(0xfff5e6, 0.5)
    frontFill.position.set(0, 0, 6)
    this.scene.add(frontFill)
  }

  createCenterIcon() {
    this.centerGroup = new THREE.Group()

    // Outer glow ring
    const glowGeometry = new THREE.RingGeometry(0.52, 0.58, 64)
    const glowMaterial = new THREE.MeshBasicMaterial({
      color: 0xc9a96e,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.3
    })
    const glow = new THREE.Mesh(glowGeometry, glowMaterial)
    glow.position.z = -0.01
    this.centerGroup.add(glow)

    // Main outer ring - gold/bronze
    const outerRingGeometry = new THREE.RingGeometry(0.44, 0.50, 64)
    const outerRingMaterial = new THREE.MeshBasicMaterial({
      color: 0xb8860b,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.9
    })
    const outerRing = new THREE.Mesh(outerRingGeometry, outerRingMaterial)
    this.centerGroup.add(outerRing)

    // Inner ring - darker
    const innerRingGeometry = new THREE.RingGeometry(0.38, 0.42, 64)
    const innerRingMaterial = new THREE.MeshBasicMaterial({
      color: 0x8b6914,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.8
    })
    const innerRing = new THREE.Mesh(innerRingGeometry, innerRingMaterial)
    innerRing.position.z = 0.005
    this.centerGroup.add(innerRing)

    // Center circle with gradient
    const circleGeometry = new THREE.CircleGeometry(0.36, 64)
    const gradientCanvas = document.createElement('canvas')
    gradientCanvas.width = 256
    gradientCanvas.height = 256
    const ctx = gradientCanvas.getContext('2d')
    const gradient = ctx.createRadialGradient(128, 128, 0, 128, 128, 128)
    gradient.addColorStop(0, '#3d2d1f')
    gradient.addColorStop(0.7, '#2d1f14')
    gradient.addColorStop(1, '#1a1208')
    ctx.fillStyle = gradient
    ctx.fillRect(0, 0, 256, 256)

    const gradientTexture = new THREE.CanvasTexture(gradientCanvas)
    const circleMaterial = new THREE.MeshBasicMaterial({
      map: gradientTexture,
      transparent: true,
      opacity: 0.95
    })
    const circle = new THREE.Mesh(circleGeometry, circleMaterial)
    circle.position.z = 0.01
    this.centerGroup.add(circle)

    // Create the icon texture with a proper book/connection symbol
    this.updateCenterIconTexture()

    // Position center BEHIND the books (negative z)
    this.centerGroup.position.z = -1
    this.scene.add(this.centerGroup)

    // Text label ABOVE center - separate from centerGroup so it renders in FRONT of books
    this.labelTexture = this.createLabelTexture(this.cyclingLabels[0])
    const labelGeometry = new THREE.PlaneGeometry(1.3, 0.32)
    this.labelMaterial = new THREE.MeshBasicMaterial({
      map: this.labelTexture,
      transparent: true,
      opacity: 1
    })
    this.labelMesh = new THREE.Mesh(labelGeometry, this.labelMaterial)
    this.labelMesh.position.set(0, -0.17, 2) // Centered on circle, in front of books (z=2)
    this.scene.add(this.labelMesh)
  }

  updateCenterIconTexture() {
    const iconCanvas = document.createElement('canvas')
    iconCanvas.width = 128
    iconCanvas.height = 128
    const ctx = iconCanvas.getContext('2d')

    // Clear
    ctx.clearRect(0, 0, 128, 128)

    // Draw a node/hub icon - central dot with radiating lines
    const centerX = 64
    const centerY = 64

    // Radiating lines
    ctx.strokeStyle = '#c9a96e'
    ctx.lineWidth = 2
    const numLines = 8
    for (let i = 0; i < numLines; i++) {
      const angle = (i / numLines) * Math.PI * 2
      const innerR = 20
      const outerR = 45
      ctx.beginPath()
      ctx.moveTo(centerX + Math.cos(angle) * innerR, centerY + Math.sin(angle) * innerR)
      ctx.lineTo(centerX + Math.cos(angle) * outerR, centerY + Math.sin(angle) * outerR)
      ctx.stroke()

      // Small dot at end of each line
      ctx.fillStyle = '#c9a96e'
      ctx.beginPath()
      ctx.arc(centerX + Math.cos(angle) * outerR, centerY + Math.sin(angle) * outerR, 4, 0, Math.PI * 2)
      ctx.fill()
    }

    // Center circle - gold gradient
    const centerGradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, 18)
    centerGradient.addColorStop(0, '#ffd700')
    centerGradient.addColorStop(0.6, '#daa520')
    centerGradient.addColorStop(1, '#b8860b')
    ctx.fillStyle = centerGradient
    ctx.beginPath()
    ctx.arc(centerX, centerY, 18, 0, Math.PI * 2)
    ctx.fill()

    // Inner highlight
    ctx.fillStyle = 'rgba(255,255,255,0.3)'
    ctx.beginPath()
    ctx.arc(centerX - 4, centerY - 4, 6, 0, Math.PI * 2)
    ctx.fill()

    const iconTexture = new THREE.CanvasTexture(iconCanvas)
    const iconGeometry = new THREE.PlaneGeometry(0.55, 0.55)
    const iconMaterial = new THREE.MeshBasicMaterial({
      map: iconTexture,
      transparent: true
    })
    const icon = new THREE.Mesh(iconGeometry, iconMaterial)
    icon.position.z = 0.02
    this.centerGroup.add(icon)
  }

  createLabelTexture(text) {
    const canvas = document.createElement('canvas')
    canvas.width = 512
    canvas.height = 128
    const ctx = canvas.getContext('2d')

    ctx.clearRect(0, 0, 512, 128)

    // Sans-serif, bold, uppercase with letter spacing
    const upperText = text.toUpperCase()
    ctx.font = 'bold 26px Arial, Helvetica, sans-serif'

    // Calculate text width for pill background
    const spacing = 3
    const chars = upperText.split('')
    const totalWidth = chars.reduce((w, c) => w + ctx.measureText(c).width + spacing, -spacing)

    // Draw pill background
    const pillPadding = 18
    const pillHeight = 42
    const pillWidth = totalWidth + pillPadding * 2
    const pillX = (512 - pillWidth) / 2
    const pillY = (128 - pillHeight) / 2
    const pillRadius = pillHeight / 2

    ctx.fillStyle = '#1a120c'
    ctx.beginPath()
    ctx.roundRect(pillX, pillY, pillWidth, pillHeight, pillRadius)
    ctx.fill()

    // Draw border
    ctx.strokeStyle = 'rgba(201, 169, 110, 0.5)'
    ctx.lineWidth = 2
    ctx.stroke()

    // Draw text
    ctx.fillStyle = '#c9a96e'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'

    let x = (512 - totalWidth) / 2
    chars.forEach(char => {
      ctx.fillText(char, x + ctx.measureText(char).width / 2, 64)
      x += ctx.measureText(char).width + spacing
    })

    return new THREE.CanvasTexture(canvas)
  }

  cycleLabel() {
    this.currentLabelIndex = (this.currentLabelIndex + 1) % this.cyclingLabels.length
    this.labelTexture = this.createLabelTexture(this.cyclingLabels[this.currentLabelIndex])
    this.labelMaterial.map = this.labelTexture
    this.labelMaterial.needsUpdate = true
  }

  createConnectionLines() {
    this.lineGroup = new THREE.Group()
    this.lines = []
    this.lineDots = [] // Store dots for each line

    const positions = this.getBookPositions()

    positions.forEach((pos, lineIndex) => {
      // Create curved connection lines
      const points = [
        new THREE.Vector3(0, 0, -1),
        new THREE.Vector3(pos.x * 0.4, pos.y * 0.4, -0.3),
        new THREE.Vector3(pos.x, pos.y, pos.z)
      ]
      const curve = new THREE.CatmullRomCurve3(points)

      const curvePoints = curve.getPoints(30)
      const geometry = new THREE.BufferGeometry().setFromPoints(curvePoints)

      const lineMaterial = new THREE.LineBasicMaterial({
        color: 0xc9a96e,
        transparent: true,
        opacity: 0
      })

      const line = new THREE.Line(geometry, lineMaterial)
      line.userData = { targetPos: pos, visible: false }
      this.lines.push(line)
      this.lineGroup.add(line)

      // Add small dots along the line for visual interest
      const dots = []
      const dotGeometry = new THREE.SphereGeometry(0.02, 8, 8)

      for (let i = 0; i < 3; i++) {
        const t = 0.25 + i * 0.25
        const point = curve.getPoint(t)
        const dotMaterial = new THREE.MeshBasicMaterial({
          color: 0xc9a96e,
          transparent: true,
          opacity: 0
        })
        const dot = new THREE.Mesh(dotGeometry, dotMaterial)
        dot.position.copy(point)
        dots.push(dot)
        this.lineGroup.add(dot)
      }
      this.lineDots.push(dots)
    })

    this.orbitGroup.add(this.lineGroup)
  }

  getBookPositions() {
    return [
      { x: -2.0, y: 1.0, z: 0.5 },
      { x: -0.6, y: 1.3, z: 0.8 },
      { x: 0.8, y: 1.2, z: 0.6 },
      { x: 1.9, y: 0.9, z: 0.3 },
      { x: -2.2, y: -0.2, z: 0.2 },
      { x: -1.2, y: -0.7, z: 0.7 },
      { x: 0.5, y: -0.9, z: 1.0 },
      { x: 1.8, y: -0.5, z: 0.4 },
    ]
  }

  spawnInitialBooks() {
    this.bookSlots = this.getBookPositions().map((pos, index) => ({
      position: pos,
      book: null,
      index
    }))

    this.usedBookIndices = new Set()

    this.bookSlots.forEach((slot, i) => {
      setTimeout(() => this.spawnBookAtSlot(slot), i * 300)
    })

    setInterval(() => this.cycleRandomBook(), 3500)
  }

  spawnBookAtSlot(slot) {
    if (slot.book) return

    let bookIndex
    const availableIndices = []
    for (let i = 0; i < this.bookData.length; i++) {
      if (!this.usedBookIndices.has(i)) availableIndices.push(i)
    }

    if (availableIndices.length === 0) {
      this.usedBookIndices.clear()
      bookIndex = Math.floor(Math.random() * this.bookData.length)
    } else {
      bookIndex = availableIndices[Math.floor(Math.random() * availableIndices.length)]
    }

    this.usedBookIndices.add(bookIndex)
    const bookInfo = this.bookData[bookIndex]

    const book = this.createBook(bookInfo, 0.75)
    book.position.set(slot.position.x, slot.position.y, slot.position.z)
    book.scale.set(0.01, 0.01, 0.01)
    book.rotation.y = Math.PI * 0.1
    book.userData = {
      targetScale: 1,
      phase: 'entering',
      enterProgress: 0,
      slot: slot,
      floatOffset: Math.random() * Math.PI * 2,
      baseY: slot.position.y
    }

    slot.book = book
    this.activeBooks.push(book)
    this.orbitGroup.add(book)

    const line = this.lines[slot.index]
    if (line) {
      line.userData.visible = true
    }
  }

  removeBookFromSlot(slot) {
    if (!slot.book) return

    const book = slot.book
    book.userData.phase = 'exiting'
    book.userData.exitProgress = 0

    const line = this.lines[slot.index]
    if (line) {
      line.userData.visible = false
    }

    setTimeout(() => {
      this.orbitGroup.remove(book)
      this.activeBooks = this.activeBooks.filter(b => b !== book)
      slot.book = null
      this.spawnBookAtSlot(slot)
    }, 1200)
  }

  cycleRandomBook() {
    const occupiedSlots = this.bookSlots.filter(s => s.book && s.book.userData.phase === 'showing')
    if (occupiedSlots.length > 0) {
      const slot = occupiedSlots[Math.floor(Math.random() * occupiedSlots.length)]
      this.removeBookFromSlot(slot)
    }
  }

  createBook(bookInfo, scale) {
    const group = new THREE.Group()
    const width = 1 * scale
    const height = 1.5 * scale
    const depth = 0.12 * scale

    const geometry = new THREE.BoxGeometry(width, height, depth)
    const materials = []

    const spineColor = new THREE.Color().setHSL(Math.random() * 0.1 + 0.05, 0.5, 0.25)
    const pageColor = new THREE.Color("#fff8f0")

    // Page edges with warm tint
    materials.push(new THREE.MeshStandardMaterial({
      color: pageColor,
      roughness: 0.7,
      emissive: 0x3d2d1f,
      emissiveIntensity: 0.05
    }))

    const spineCanvas = this.createSpineTexture(bookInfo.spine, spineColor)
    const spineTexture = new THREE.CanvasTexture(spineCanvas)
    materials.push(new THREE.MeshStandardMaterial({
      map: spineTexture,
      roughness: 0.4,
      metalness: 0.1,
      emissive: 0x2d1f14,
      emissiveIntensity: 0.1
    }))

    materials.push(new THREE.MeshStandardMaterial({
      color: pageColor,
      roughness: 0.7,
      emissive: 0x3d2d1f,
      emissiveIntensity: 0.05
    }))
    materials.push(new THREE.MeshStandardMaterial({
      color: pageColor,
      roughness: 0.7,
      emissive: 0x3d2d1f,
      emissiveIntensity: 0.05
    }))

    const coverTexture = this.textureLoader.load(bookInfo.cover, (tex) => {
      tex.colorSpace = THREE.SRGBColorSpace
    })
    // Warm beige tint on covers - color multiplies with texture
    materials.push(new THREE.MeshStandardMaterial({
      map: coverTexture,
      color: 0xfff8f0, // Warm white tint
      roughness: 0.2,
      metalness: 0.08,
      emissive: 0x3d2d1f, // Subtle warm glow
      emissiveIntensity: 0.15
    }))

    const backCanvas = this.createBackTexture(bookInfo.back, spineColor)
    const backTexture = new THREE.CanvasTexture(backCanvas)
    materials.push(new THREE.MeshStandardMaterial({
      map: backTexture,
      roughness: 0.35,
      metalness: 0.05,
      emissive: 0x2d1f14,
      emissiveIntensity: 0.1
    }))

    const mesh = new THREE.Mesh(geometry, materials)
    group.add(mesh)

    return group
  }

  createSpineTexture(text, baseColor) {
    const canvas = document.createElement('canvas')
    canvas.width = 64
    canvas.height = 512
    const ctx = canvas.getContext('2d')

    ctx.fillStyle = `rgb(${Math.floor(baseColor.r*255)},${Math.floor(baseColor.g*255)},${Math.floor(baseColor.b*255)})`
    ctx.fillRect(0, 0, 64, 512)

    ctx.save()
    ctx.translate(32, 256)
    ctx.rotate(-Math.PI / 2)
    ctx.fillStyle = '#d4c4a8'
    ctx.font = 'bold 28px Georgia, serif'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'

    const maxWidth = 480
    let fontSize = 28
    ctx.font = `bold ${fontSize}px Georgia, serif`
    while (ctx.measureText(text).width > maxWidth && fontSize > 12) {
      fontSize -= 2
      ctx.font = `bold ${fontSize}px Georgia, serif`
    }

    ctx.fillText(text, 0, 0)
    ctx.restore()

    return canvas
  }

  createBackTexture(text, baseColor) {
    const canvas = document.createElement('canvas')
    canvas.width = 256
    canvas.height = 384
    const ctx = canvas.getContext('2d')

    const r = Math.floor(baseColor.r * 255 * 0.9)
    const g = Math.floor(baseColor.g * 255 * 0.9)
    const b = Math.floor(baseColor.b * 255 * 0.9)
    ctx.fillStyle = `rgb(${r},${g},${b})`
    ctx.fillRect(0, 0, 256, 384)

    ctx.fillStyle = '#d4c4a8'
    ctx.font = '18px Georgia, serif'
    ctx.textAlign = 'center'

    const words = text.split(' ')
    const lines = []
    let currentLine = ''
    const maxWidth = 220

    words.forEach(word => {
      const testLine = currentLine + (currentLine ? ' ' : '') + word
      if (ctx.measureText(testLine).width > maxWidth) {
        lines.push(currentLine)
        currentLine = word
      } else {
        currentLine = testLine
      }
    })
    if (currentLine) lines.push(currentLine)

    const lineHeight = 26
    const startY = (384 - lines.length * lineHeight) / 2

    lines.forEach((line, i) => {
      ctx.fillText(line, 128, startY + i * lineHeight)
    })

    return canvas
  }

  setupResizeObserver() {
    this.resizeObserver = new ResizeObserver(() => this.handleResize())
    this.resizeObserver.observe(this.canvasTarget.parentElement)
  }

  handleResize() {
    if (!this.renderer || !this.camera) return
    const container = this.canvasTarget.parentElement
    const width = container.clientWidth
    const height = container.clientHeight || 450
    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()
    this.renderer.setSize(width, height)
  }

  easeOutBack(x) {
    const c1 = 1.70158
    const c3 = c1 + 1
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2)
  }

  easeInBack(x) {
    const c1 = 1.70158
    const c3 = c1 + 1
    return c3 * x * x * x - c1 * x * x
  }

  animate() {
    if (!this.renderer) return
    this.animationId = requestAnimationFrame(() => this.animate())

    const delta = this.clock.getDelta()
    this.time += delta

    // Animate shimmer light - SLOWER for subtle effect
    this.shimmerLight.position.x = Math.sin(this.time * 0.4) * 3
    this.shimmerLight.position.y = Math.cos(this.time * 0.3) * 2
    this.shimmerLight.intensity = 0.3 + Math.sin(this.time * 0.5) * 0.1

    // Subtle center icon pulse
    const pulse = 1 + Math.sin(this.time * 1.5) * 0.03
    this.centerGroup.scale.set(pulse, pulse, 1)

    // Slowly rotate the entire orbit of books and lines around center
    const orbitAngle = this.time * 0.015
    this.orbitGroup.rotation.z = orbitAngle

    // Animate connection lines opacity - smoother fade in/out
    this.lines.forEach((line, index) => {
      const targetOpacity = line.userData.visible ? 0.45 : 0
      line.material.opacity += (targetOpacity - line.material.opacity) * 0.03

      // Also fade the dots on this line
      if (this.lineDots && this.lineDots[index]) {
        this.lineDots[index].forEach(dot => {
          const dotTargetOpacity = line.userData.visible ? 0.5 : 0
          dot.material.opacity += (dotTargetOpacity - dot.material.opacity) * 0.03
        })
      }
    })

    // Animate books
    this.activeBooks.forEach(book => {
      const data = book.userData

      // Counter-rotate to keep books upright while orbiting
      book.rotation.z = -orbitAngle

      if (data.phase === 'entering') {
        data.enterProgress += delta * 1.8
        const progress = Math.min(data.enterProgress, 1)
        const easedScale = this.easeOutBack(progress) * 0.75

        book.scale.set(easedScale, easedScale, easedScale)
        book.rotation.y = (1 - progress) * Math.PI * 0.3

        if (progress >= 1) {
          data.phase = 'showing'
        }
      } else if (data.phase === 'showing') {
        book.rotation.y = Math.sin(this.time * 0.8 + data.floatOffset) * 0.25
        book.rotation.x = Math.sin(this.time * 0.6 + data.floatOffset + 1) * 0.08
        book.position.y = data.baseY + Math.sin(this.time * 0.5 + data.floatOffset) * 0.04
      } else if (data.phase === 'exiting') {
        data.exitProgress += delta * 2
        const progress = Math.min(data.exitProgress, 1)
        const easedScale = (1 - this.easeInBack(progress)) * 0.75

        book.scale.set(easedScale, easedScale, easedScale)

        book.traverse((child) => {
          if (child.material) {
            if (Array.isArray(child.material)) {
              child.material.forEach(mat => {
                mat.transparent = true
                mat.opacity = 1 - progress
              })
            } else {
              child.material.transparent = true
              child.material.opacity = 1 - progress
            }
          }
        })
      }
    })

    this.renderer.render(this.scene, this.camera)
  }

  cleanup() {
    if (this.animationId) cancelAnimationFrame(this.animationId)
    if (this.observer) this.observer.disconnect()
    if (this.resizeObserver) this.resizeObserver.disconnect()
    if (this.renderer) this.renderer.dispose()
  }
}
